import React, { useContext, useState } from 'react'
import { Container, Footer, InputContainer, Title } from './styled'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { Button } from '../../../../components/common/Button'
import { Context } from '../../../../context/context_employee'
import { Modal } from '../../../../components/Modal'
import { CheckCircle } from '@phosphor-icons/react/dist/ssr'
import { WarningCircle } from '@phosphor-icons/react'
import { set } from 'date-fns'

export const NewUser = () => {
  const {
    formData,
    setFormData,
    baseName,
    baseOptions,
    outpostOption,
    findBaseName,
    handleCreateEmployee,
    maskPhone,
    errorModal,
    setErrorModal,
    errorMessage,
    registered,
  } = useContext(Context)

  const [confirm, setConfirm] = useState(false)

  const [passwordStrong, setPasswordStrong] = useState(false)
  const [passwordError, setPasswordError] = useState('')

  const checkPasswordStrength = (password) => {
    const minLength = 8

    if (password.length < minLength) {
      setPasswordError(`A senha deve ter pelo menos ${minLength} caracteres.`)
      setPasswordStrong(false)
      return false
    }

    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumber = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    if (!hasUpperCase) {
      setPasswordError('A senha deve conter pelo menos uma letra maiúscula.')
      setPasswordStrong(false)
      return false
    } else if (!hasLowerCase) {
      setPasswordError('A senha deve conter pelo menos uma letra minúscula.')
      setPasswordStrong(false)
      return false
    } else if (!hasNumber) {
      setPasswordError('A senha deve conter pelo menos um número.')
      setPasswordStrong(false)
      return false
    } else if (!hasSpecialChar) {
      setPasswordError('A senha deve conter pelo menos um símbolo especial.')
      setPasswordStrong(false)
      return false
    }
    setPasswordError('')
    setPasswordStrong(true)
    return true
  }

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value

    setFormData((prevData) => ({
      ...prevData,
      password: newPassword,
    }))

    checkPasswordStrength(newPassword)
  }

  return (
    <>
      <Container
        onSubmit={(e) => {
          e.preventDefault()
          if (passwordStrong) {
            setConfirm((prev) => !prev)
          }
        }}
      >
        <InputContainer>
          <Select
            onchange={(e) =>
              setFormData?.((prev: any) => ({
                ...prev,
                Employee: { ...prev.Employee, type: e.target.value },
              }))
            }
            label={{
              title: 'Tipo de acesso',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            data={[
              { id: 'EMPLOYEE', value: 'Funcionário' },
              { id: 'OUTPOST', value: 'Posto' },
            ]}
            backgroundcolor=""
            bordercolor=""
            currentOption={formData?.Employee?.type}
            outlinecolor=""
          />
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Nome do usuário"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                name="name"
                value={formData?.UserInfo?.name}
                onChange={(e) =>
                  setFormData?.((prev: any) => ({
                    ...prev,
                    UserInfo: {
                      ...prev.UserInfo,
                      name: e?.target?.value || '',
                    },
                  }))
                }
                type="text"
                placeholder="Usuário"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="E-mail" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                onChange={(e) =>
                  setFormData?.((prev: any) => ({
                    ...prev,
                    UserInfo: { ...prev.UserInfo, email: e.target.value },
                  }))
                }
                value={formData?.UserInfo?.email || ''}
                type="email"
                placeholder="Informe seu e-mail"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Telefone" htmlFor="" color="" fontSize="14px" />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                onChange={(e) =>
                  setFormData?.((prev: any) => ({
                    ...prev,
                    UserInfo: { ...prev.UserInfo, phone: e.target.value },
                  }))
                }
                value={maskPhone(formData?.UserInfo.phone || '')}
                type="tel"
                placeholder="(XX) XXXXX-XXXX"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label
              title="Data de Nascimento"
              htmlFor=""
              color=""
              fontSize="14px"
            />
            <Input.Wrapper
              borderColor="#CECECE"
              backgroundColor="#F7F7F7"
              outlineColor=""
            >
              <Input.Content
                id=""
                onChange={(e) =>
                  setFormData?.((prev: any) => ({
                    ...prev,
                    UserInfo: { ...prev.UserInfo, birthdate: e.target.value },
                  }))
                }
                value={formData?.UserInfo.birthdate || ''}
                type="date"
                placeholder="00/00/0000"
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Select
            onchange={(e) => {
              setFormData?.((prev: any) => ({
                ...prev,
                Employee: { ...prev.Employee, id_base: e.target.value },
              }))
              findBaseName(e.target.value)
            }}
            label={{
              title: 'Base responsável',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            data={baseOptions || []}
            backgroundcolor=""
            bordercolor=""
            currentOption={baseName}
            outlinecolor=""
          />
        </InputContainer>

        <InputContainer>
          <Select
            onchange={(e) => {
              setFormData?.((prev: any) => ({
                ...prev,
                outpost: e.target.value,
              }))
            }}
            label={{
              title: 'Posto de trabalho',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            data={outpostOption || []}
            backgroundcolor=""
            bordercolor=""
            currentOption={formData?.outpost}
            outlinecolor=""
          />
        </InputContainer>

        <InputContainer>
          <Select
            label={{
              title: 'Função do usuário',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            onchange={(e) => {
              setFormData?.((prev: any) => ({
                ...prev,
                role: e.target.value,
              }))
            }}
            data={[
              { id: 'ADMINISTRADOR', value: 'ADMINISTRADOR' },
              // { id: 'FUNCIONARIO', value: 'FUNCIONARIO' },
              { id: 'SEGURANCA', value: 'SEGURANCA' },
              // { id: 'MORADOR_ADM', value: 'MORADOR_ADM' },
              // { id: 'MORADOR', value: 'MORADOR' },
            ]}
            backgroundcolor=""
            bordercolor=""
            currentOption={formData?.role}
            outlinecolor=""
          />
        </InputContainer>

        {formData.role.length > 0 && (
          <>
            <Title>Informação de acesso</Title>
            <InputContainer>
              <Input.Root>
                <Input.Label
                  title="Usuário - Login"
                  htmlFor=""
                  color=""
                  fontSize="14px"
                />
                <Input.Wrapper
                  borderColor="#CECECE"
                  backgroundColor="#F7F7F7"
                  outlineColor=""
                >
                  <Input.Content
                    id=""
                    type="text"
                    placeholder="Login"
                    value={formData?.login}
                    onChange={(e) =>
                      setFormData?.((prev: any) => ({
                        ...prev,
                        login: e.target.value,
                      }))
                    }
                    required
                  />
                </Input.Wrapper>
              </Input.Root>
            </InputContainer>
            <InputContainer>
              <Input.Root>
                <Input.Label
                  title="Senha de acesso"
                  htmlFor=""
                  color=""
                  fontSize="14px"
                />
                <Input.Wrapper
                  borderColor="#CECECE"
                  backgroundColor="#F7F7F7"
                  outlineColor=""
                >
                  <Input.Content
                    id=""
                    // onchange={(e: any) => (e.target.value)}
                    value={formData?.password}
                    onChange={handlePasswordChange}
                    // onChange={(e) =>
                    //   setFormData?.((prev: any) => ({
                    //     ...prev,
                    //     password: e.target.value,
                    //   }))
                    // }
                    type="password"
                    placeholder="Senha"
                    required
                  />
                </Input.Wrapper>
                {!passwordStrong && (
                  <div style={{ color: 'red' }}>{passwordError}</div>
                )}
              </Input.Root>
            </InputContainer>
          </>
        )}
        <Footer>
          <Button.Root
            backgroundColor="#308EC6"
            // onClick={() => {
            //   isFormDataValid && isFormDataValid(setConfirm)
            // }}
            // onClick={}
            type="submit"
          >
            <Button.Content title="Cadastrar" color="#fff" fontSize="16px" />
          </Button.Root>
        </Footer>
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={confirm}
          setIsOpenController={() => setConfirm((prev) => !prev)}
        >
          <Modal.Header onclick={() => setConfirm((prev) => !prev)} />
          <Modal.Content
            value="Você deseja realmente fazer o cadastro?"
            subvalue="Ao clicar em cadastrar, um novo usuário será criado."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => setConfirm((prev) => !prev)}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#308EC6"
              onClick={(e) => {
                handleCreateEmployee(e)
                setConfirm((prev) => !prev)
              }}
            >
              <Button.Content title="Sim, enviar" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          height="fit-content"
          width="35%"
          left="50%"
          top="50%"
          open={registered}
          setIsOpenController={() => location.reload()}
        >
          <Modal.Header onclick={() => location.reload()} />
          <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
          <Modal.Content
            value="Usuário cadastrado!"
            subvalue="Pegue o usuário de acesso e sua senha e encaminhe para o usuário que acessará e usará o sistema. Os dados serão encaminhados via e-mail também."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#00517D"
              onClick={() => location.reload()}
            >
              <Button.Content title="Voltar para página" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>
      </Container>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="30%"
        height="fit-content"
        left="50%"
        top="50%"
        open={errorModal}
        setIsOpenController={() => {
          setErrorModal(false)
        }}
      >
        <Modal.Icon
          icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
        />
        <Modal.Content value="Erro ao criar usuário" subvalue={errorMessage} />
      </Modal.Root>
    </>
  )
}
